const iconSquareCheck = `<svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 448 512" role='presentation'><path d="M211.8 339.8C200.9 350.7 183.1 350.7 172.2 339.8L108.2 275.8C97.27 264.9 97.27 247.1 108.2 236.2C119.1 225.3 136.9 225.3 147.8 236.2L192 280.4L300.2 172.2C311.1 161.3 328.9 161.3 339.8 172.2C350.7 183.1 350.7 200.9 339.8 211.8L211.8 339.8zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z"/></svg>`
const iconSquare = `<svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 448 512" role='presentation'><path d="M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM384 80H64C55.16 80 48 87.16 48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80z"/></svg>`;
const iconChevronLeft = `<svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 320 512" role='presentation'><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg>`;
const iconChevronRight = `<svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 320 512" role='presentation'><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg>`;
const iconDown = `<svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 448 512" role='presentation'><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"/></svg>`;

if (
  typeof window.algoliaSettings.appID !== 'undefined' &&
  typeof window.algoliaSettings.searchID !== 'undefined'
) {

  let url = new URL(window.location.href);
  let blogonlyString = url.searchParams.get("blogonly");

  if(blogonlyString == null) {
    let articlesString = url.searchParams.get("shopify_articles[query]");
    if(articlesString != null) blogonlyString = 'true';
    $('.back-to-blog').css('display', 'none');
  }

  if (blogonlyString != 'true') {
    $('.back-to-blog').css('display', 'none');

    const searchClient = algoliasearch(
      window.algoliaSettings.appID,
      window.algoliaSettings.searchID
    );

    const blogSearch = instantsearch({
      indexName: 'shopify_articles',
      searchClient,
      searchParameters: {
        hitsPerPage: 6
      }
    });

    const collectionsSearch = instantsearch({
      indexName: 'shopify_collections',
      searchClient,
      searchParameters: {
        hitsPerPage: 3
      }
    });

    const search = instantsearch({
      indexName: 'shopify_products',
      searchClient,
      routing: true,
      searchFunction: function (helper) {
        var query = helper.state.query;
        blogSearch.helper.setQuery(query);
        blogSearch.helper.search();
        collectionsSearch.helper.setQuery(query);
        collectionsSearch.helper.search();
        helper.search();
      },
    });

    // Template helpers
    search.templatesConfig.helpers.flavor = function () {
      if ('flavor' in this.options) {
        return this.options.flavor;
      }
    };


    // Paginatiion render
    const renderPagination = (renderOptions, isFirstRender) => {
      const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
      } = renderOptions;

      const container = document.querySelector('#pagination');

      container.innerHTML = `
      <ul class="pagination__list list-unstyled" role="list">
        <div class="left">
          <li class="prev ${isFirstPage ? 'disabled' : ''}">
            <a
              href="${createURL(currentRefinement - 1)}"
              class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
              data-value="${currentRefinement - 1}"
            >
            ${iconChevronLeft}  PREV
            </a>
          </li>
        </div>
        <div class="center">
        ${pages
        .map(
          page => `
              <li>
                <a
                  href="${createURL(page)}"
                  class="pagination__item link ${currentRefinement === page ? 'pagination__item--current' : ''}"
                  data-value="${page}"
                >
                  ${page + 1}
                </a>
              </li>
            `
        )
        .join('')}
          </div>
          <div class="right">
            <li class="next ${isLastPage ? 'disabled' : ''}">
              <a
                href="${createURL(currentRefinement + 1)}"
                class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                data-value="${currentRefinement + 1}"
              >
              NEXT  ${iconChevronRight}
              </a>
            </li>
          </div>
      </ul>
    `;

      [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          refine(event.currentTarget.dataset.value);
        });
      });
    };
    // Create the custom widget
    const customPagination = instantsearch.connectors.connectPagination(
      renderPagination
    );

    // Sort by dropdown
    const renderSortBy = (renderOptions, isFirstRender) => {
      const {
        options,
        currentRefinement,
        hasNoResults,
        refine,
        widgetParams,
      } = renderOptions;

      if (isFirstRender) {
        const selElem = document.createElement('div');
        selElem.classList.add('sort-box');
        let defaultText = 'Sort by:'
        if (currentRefinement) {
          let selectedRef = options.find(obj => {
            return obj.value === currentRefinement
          })
          if (typeof selectedRef != 'undefined') {
            defaultText = selectedRef.label;
          }
        }

        selElem.innerHTML = `<div class="sort-box__selected" aria-control="sort-box__list"><span id="sort_place">${defaultText}</span>${iconDown}</div><ul id="sort-box__list" class="sort-box__list"></ul>`;

        widgetParams.container.appendChild(selElem);
        const select = widgetParams.container.querySelector('.sort-box__list');
      }

      const select = widgetParams.container.querySelector('ul');

      select.disabled = hasNoResults;

      let optionsList = `
      ${options
        .map(
          option => `
            <li
              data-value="${option.value}"
              ${option.value === currentRefinement ? 'class="selected"' : ''}
            >
             ${option.label}
            </li>
          `
        )
        .join('')}
    `;
      select.innerHTML = optionsList;
      [...widgetParams.container.querySelectorAll('li')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          let sortPlace = widgetParams.container.querySelector('#sort_place');
          sortPlace.innerText = event.target.innerText;
          refine(event.currentTarget.dataset.value);

        });
      });
    };
    const customSortBy = instantsearch.connectors.connectSortBy(renderSortBy);

    // Sidebar filters
    const renderRefinementList = (renderOptions, isFirstRender) => {
      const {
        items,
        isFromSearch,
        refine,
        createURL,
        isShowingMore,
        canToggleShowMore,
        searchForItems,
        toggleShowMore,
        widgetParams
      } = renderOptions;

      if (isFirstRender) {
        const selElem = document.createElement('div');
        selElem.classList.add('dropdown-menu');
        widgetParams.container.appendChild(selElem);
      }

      let select = widgetParams.container.querySelector('div');

      if (items.length <= 0) {
        widgetParams.container.parentNode.classList.add('dropdown-component--is-empty')
      } else {
        widgetParams.container.parentNode.classList.remove('dropdown-component--is-empty')
      }
      let optionsList = `
      ${items
        .map(
          option => `
            <a
              href="#"
              data-value="${option.value}"
              ${option.isRefined ? 'style="font-weight: bold;"' : ''}
              >
              ${option.isRefined ? iconSquareCheck : iconSquare}
              ${option.label}
            </a>
          `
        )
        .join('')}
    `;
      select.innerHTML = optionsList;

      [...widgetParams.container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          refine(event.currentTarget.dataset.value);
        });
      });
    };
    const customRefinementList = instantsearch.connectors.connectRefinementList(
      renderRefinementList
    );

    search.addWidgets([
      instantsearch.widgets.searchBox({
        container: '.search_wrap',
        templates: {
          submit: `<button type="submit" class="search_button" aria-label="Search">
        <svg class="icon icon-search" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 512 512" role="presentation"><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"></path></svg>
      </button>`
        },
        cssClasses: {
          input: 'search__input field__input'
        },
        showReset: false,
        showLoadingIndicator: false,
      }),
      instantsearch.widgets.configure({
        hitsPerPage: 12,
      }),
      instantsearch.widgets.hits({
        container: '#ProductGridContainer',
        transformItems(items) {

          if(items.length < 1) {
            $('.search-container').hide();
            $('.not-found-container').show();
          }
          else {
            $('.search-container').show();
            $('.not-found-container').hide();
          }

          let newItems = items.map(function(item) {
            item.isOnSale = item.compare_at_price > item.price && item.inventory_available;

            if(typeof item.product_type != "undefined" &&
              item.product_type != "Bundle"
            ) {
              $.ajax({
                type: 'GET',
                url: window.Shopify.routes.root + 'products/' + item.handle + '.json',
                dataType: 'jsonp',
                success: function (data) {
                  let type = data.product.product_type;
                  if(
                    type.indexOf('Gear') < 0 &&
                    type.indexOf('Accessories') < 0 &&
                    type.indexOf('Custom Bundle') < 0
                  ) {
                    // updateAlgoliaServings(item.id, data.product.variants, data.product.handle);
                    updateAlgoliaFlavors(item.id, data.product.variants);
                  }
                }
              });
            }

            return item;
          });

          return newItems;
        },
        templates: {
          item: document.getElementById('algolia-search-tpl').innerHTML,
          empty: "No results",
        },
        cssClasses: {
          list: 'grid product-grid grid--1-col grid--2-col-tablet-down grid--3-col-desktop algolia-product-grid',
          item: 'grid__item',
        },
      }),

      // Collection pagination
      customPagination({
        container: '#collectionPagination',
        scrollTo: document.querySelector('#shopify-section-header')
      }),
      instantsearch.widgets.stats({
        container: '.search-stats--desktop',
        templates: {
          text: `
            {{#hasNoResults}}No results{{/hasNoResults}}
            {{#hasOneResult}}1 Product Found{{/hasOneResult}}
            {{#hasManyResults}}{{nbHits}} Products Found{{/hasManyResults}}
        `,
        },
      }),
      instantsearch.widgets.stats({
        container: '.search-stats--mobile',
        templates: {
          text: `
          {{#hasNoResults}}No results{{/hasNoResults}}
          {{#hasOneResult}}1 Product Found{{/hasOneResult}}
          {{#hasManyResults}}{{nbHits}} Products Found{{/hasManyResults}}
        `,
        },
      }),
      // sort by dropdown
      customSortBy({
        container: document.querySelector('#algolia-sorting'),
        items: [
          {label: 'From A-Z', value: 'shopify_products_title_asc'},
          {label: 'From Z-A', value: 'shopify_products_title_desc'},
          {label: 'Price: Low to High', value: 'shopify_products_price_asc'},
          {label: 'Price: High to Low', value: 'shopify_products_price_desc'},
        ],
      }),

      customRefinementList({
        container: document.querySelector('#search-cat-filter'),
        attribute: 'named_tags.category',
        sortBy: ['name'],
        heading: 'Category'
      }),
      customRefinementList({
        container: document.querySelector('#search-goal-filter'),
        attribute: 'named_tags.goal',
        sortBy: ['name'],
        heading: 'Goal'
      }),
      customRefinementList({
        container: document.querySelector('#search-ingredient-filter'),
        attribute: 'named_tags.ingredient',
        sortBy: ['name'],
        heading: 'Ingredient'
      }),
      customRefinementList({
        container: document.querySelector('#search-brand-filter'),
        attribute: 'named_tags.brand',
        sortBy: ['name'],
        heading: 'Brand'
      }),
    ]);

    blogSearch.addWidgets([
      instantsearch.widgets.hits({
        container: '#search-blog-hits',
        templates: {
          item: `<li><a href="/blogs/{{ blog.handle}}/{{handle}}">{{title }}</a></li>`,
          empty: "No results",
        },
      }),
      instantsearch.widgets.configure({
        hitsPerPage: 6,
      })
    ]);

    collectionsSearch.addWidgets([
      instantsearch.widgets.hits({
        container: '#search-collections-hits',
        templates: {
          item: `<li><a href="/collections/{{handle}}">{{title }}</a></li>`,
          empty: "No results",
        },
      }),
      instantsearch.widgets.configure({
        hitsPerPage: 3,
      })
    ]);

    collectionsSearch.start();
    blogSearch.start();
    search.start();

  }

  else {

    function clearInput(){
      var getValue = document.querySelector(".ais-SearchBox-input.search__input");
      if (getValue.value != "") {
        getValue.value = "";
      }
    }

    const searchClient = algoliasearch(
      window.algoliaSettings.appID,
      window.algoliaSettings.searchID
    );

    $('.search-products, .search-sidebar').addClass('blogonly');


    const productSearch = instantsearch({
      indexName: 'shopify_products',
      searchClient,
      searchParameters: {
        hitsPerPage: 6
      }
    });

    const collectionsSearch = instantsearch({
      indexName: 'shopify_collections',
      searchClient,
      searchParameters: {
        hitsPerPage: 3
      }
    });

    const search = instantsearch({
      indexName: 'shopify_articles',
      searchClient,
      routing: true,
      searchFunction: function (helper) {
        var query = helper.state.query;
        productSearch.helper.setQuery(query);
        productSearch.helper.search();
        collectionsSearch.helper.setQuery(query);
        collectionsSearch.helper.search();
        helper.search();
      },
    });

    // Template helpers
    search.templatesConfig.helpers.flavor = function () {
      if ('flavor' in this.options) {
        return this.options.flavor;
      }
    };


    // Paginatiion render
    const renderPagination = (renderOptions, isFirstRender) => {
      const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
      } = renderOptions;

      const container = document.querySelector('#pagination');

      container.innerHTML = `
      <ul class="pagination__list list-unstyled" role="list">
        <div class="left">
          <li class="prev ${isFirstPage ? 'disabled' : ''}">
            <a
              href="${createURL(currentRefinement - 1)}"
              class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
              data-value="${currentRefinement - 1}"
            >
            ${iconChevronLeft}  PREV
            </a>
          </li>
        </div>
        <div class="center">
        ${pages
        .map(
          page => `
              <li>
                <a
                  href="${createURL(page)}"
                  class="pagination__item link ${currentRefinement === page ? 'pagination__item--current' : ''}"
                  data-value="${page}"
                >
                  ${page + 1}
                </a>
              </li>
            `
        )
        .join('')}
          </div>
          <div class="right">
            <li class="next ${isLastPage ? 'disabled' : ''}">
              <a
                href="${createURL(currentRefinement + 1)}"
                class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                data-value="${currentRefinement + 1}"
              >
              NEXT  ${iconChevronRight}
              </a>
            </li>
          </div>
      </ul>
    `;

      [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          refine(event.currentTarget.dataset.value);
        });
      });
    };
    // Create the custom widget
    const customPagination = instantsearch.connectors.connectPagination(
      renderPagination
    );

    // Sort by dropdown
    const renderSortBy = (renderOptions, isFirstRender) => {
      const {
        options,
        currentRefinement,
        hasNoResults,
        refine,
        widgetParams,
      } = renderOptions;

      if (isFirstRender) {
        const selElem = document.createElement('div');
        selElem.classList.add('sort-box');
        let defaultText = 'Sort by:'
        if (currentRefinement) {
          let selectedRef = options.find(obj => {
            return obj.value === currentRefinement
          })
          if (typeof selectedRef != 'undefined') {
            defaultText = selectedRef.label;
          }
        }

        selElem.innerHTML = `<div class="sort-box__selected" aria-control="sort-box__list"><span id="sort_place">${defaultText}</span>${iconDown}</div><ul id="sort-box__list" class="sort-box__list"></ul>`;

        widgetParams.container.appendChild(selElem);
        const select = widgetParams.container.querySelector('.sort-box__list');
      }

      const select = widgetParams.container.querySelector('ul');

      select.disabled = hasNoResults;

      let optionsList = `
      ${options
        .map(
          option => `
            <li
              data-value="${option.value}"
              ${option.value === currentRefinement ? 'class="selected"' : ''}
            >
             ${option.label}
            </li>
          `
        )
        .join('')}
    `;
      select.innerHTML = optionsList;
      [...widgetParams.container.querySelectorAll('li')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          let sortPlace = widgetParams.container.querySelector('#sort_place');
          sortPlace.innerText = event.target.innerText;
          refine(event.currentTarget.dataset.value);

        });
      });
    };
    const customSortBy = instantsearch.connectors.connectSortBy(renderSortBy);

    // Sidebar filters
    const renderRefinementList = (renderOptions, isFirstRender) => {
      const {
        items,
        isFromSearch,
        refine,
        createURL,
        isShowingMore,
        canToggleShowMore,
        searchForItems,
        toggleShowMore,
        widgetParams
      } = renderOptions;

      if (isFirstRender) {
        const selElem = document.createElement('div');
        selElem.classList.add('dropdown-menu');
        widgetParams.container.appendChild(selElem);
      }

      let select = widgetParams.container.querySelector('div');

      if (items.length <= 0) {
        widgetParams.container.parentNode.classList.add('dropdown-component--is-empty')
      } else {
        widgetParams.container.parentNode.classList.remove('dropdown-component--is-empty')
      }
      let optionsList = `
      ${items
        .map(
          option => `
            <a
              href="#"
              data-value="${option.value}"
              ${option.isRefined ? 'style="font-weight: bold;"' : ''}
              >
              ${option.isRefined ? iconSquareCheck : iconSquare}
              ${option.label}
            </a>
          `
        )
        .join('')}
    `;
      select.innerHTML = optionsList;

      [...widgetParams.container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
          event.preventDefault();
          refine(event.currentTarget.dataset.value);
        });
      });
    };
    const customRefinementList = instantsearch.connectors.connectRefinementList(
      renderRefinementList
    );

    search.addWidgets([
      instantsearch.widgets.searchBox({
        container: '.search_wrap',
        templates: {
          submit: `<button type="submit" class="search_button" aria-label="Search">
        <svg class="icon icon-search" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 512 512" role="presentation"><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"></path></svg>
      </button>`
        },
        cssClasses: {
          input: 'search__input field__input'
        },
        showReset: false,
        showLoadingIndicator: false,
      }),
      instantsearch.widgets.configure({
        hitsPerPage: 12,
      }),
      instantsearch.widgets.hits({
        container: '#ProductGridContainer',
        transformItems(items) {
          return items.map(item => ({
            ...item,
            isOnSale: item.compare_at_price > item.price && item.inventory_available,
          }));
        },
        templates: {
          item: document.getElementById('algolia-search-tpl').innerHTML,
          empty: "No results",
        },
        cssClasses: {
          list: 'grid product-grid grid--1-col grid--2-col-tablet-down grid--3-col-desktop algolia-product-grid',
          item: 'grid__item',
        },
      }),

      // Collection pagination
      customPagination({
        container: '#collectionPagination',
        scrollTo: document.querySelector('#shopify-section-header')
      }),
      instantsearch.widgets.stats({
        container: '.search-stats--desktop',
        templates: {
          text: `
            {{#hasNoResults}}No results{{/hasNoResults}}
            {{#hasOneResult}}1 Article Found{{/hasOneResult}}
            {{#hasManyResults}}{{nbHits}} Articles Found{{/hasManyResults}}
        `,
        },
      }),
      instantsearch.widgets.stats({
        container: '.search-stats--mobile',
        templates: {
          text: `
          {{#hasNoResults}}No results{{/hasNoResults}}
          {{#hasOneResult}}1 Article Found{{/hasOneResult}}
          {{#hasManyResults}}{{nbHits}} Articles Found{{/hasManyResults}}
        `,
        },
      }),
      // sort by dropdown
      customSortBy({
        container: document.querySelector('#algolia-sorting'),
        items: [
          {label: 'From A-Z', value: 'shopify_articles_title_asc'},
          {label: 'From Z-A', value: 'shopify_articles_title_desc'},
          {label: 'Price: Low to High', value: 'shopify_articles_price_asc'},
          {label: 'Price: High to Low', value: 'shopify_articles_price_desc'},
        ],
      }),

      customRefinementList({
        container: document.querySelector('#search-cat-filter'),
        attribute: 'named_tags.category',
        sortBy: ['name'],
        heading: 'Category'
      }),
      customRefinementList({
        container: document.querySelector('#search-goal-filter'),
        attribute: 'named_tags.goal',
        sortBy: ['name'],
        heading: 'Goal'
      }),
      customRefinementList({
        container: document.querySelector('#search-ingredient-filter'),
        attribute: 'named_tags.ingredient',
        sortBy: ['name'],
        heading: 'Ingredient'
      }),
      customRefinementList({
        container: document.querySelector('#search-brand-filter'),
        attribute: 'named_tags.brand',
        sortBy: ['name'],
        heading: 'Brand'
      }),
    ]);

    productSearch.addWidgets([
      instantsearch.widgets.hits({
        container: '#search-blog-hits',
        templates: {
          item: `<li><a href="/products/{{handle}}">{{title }}</a></li>`,
          empty: "No results",
        },
      }),
      instantsearch.widgets.configure({
        hitsPerPage: 6,
      })
    ]);

    collectionsSearch.addWidgets([
      instantsearch.widgets.hits({
        container: '#search-collections-hits',
        templates: {
          item: `<li><a href="/collections/{{handle}}">{{title }}</a></li>`,
          empty: "No results",
        },
      }),
      instantsearch.widgets.configure({
        hitsPerPage: 3,
      })
    ]);

    collectionsSearch.start();
    productSearch.start();
    search.start();

    $('#ProductGridContainer').one('DOMSubtreeModified', function(){
      $('#ProductGridContainer .grid__item .full-unstyled-link').each(function() {
        $(this).attr('href', $(this).attr('data-bloglink'));
      });
    });

  }
}

// if(typeof updateAlgoliaServings == "undefined") {
//   function updateAlgoliaServings(id, variants, handle) {
//     let target = $('[data-id*="'+id+'"] .card--servings');
//     let servings = [];
//     let variantIds = [];

//     variants.forEach(function(variant) {
//       if (
//         typeof variant.option1 != "undefined" &&
//         !servings.includes(variant.option1) &&
//         variant.option1.indexOf('Bundle App') < 0
//       ) {
//         servings.push(variant.option1);
//         variantIds.push(variant.id);
//       }
//     });

//     let i = 0;
//     servings.forEach(function(serving) {
//       if(target.find(`[data-serving="${serving}"]`).length < 1) {
//         let servingClass = '';
//         if(i < 1) servingClass = 'active';
//         let url = window.Shopify.routes.root + `products/${handle}?variant=${variantIds[i]}`;
//         target.append(`<a href="${url}" class="serving ${servingClass}" data-serving="${serving}">${serving}</a>`);
//       }
//       i++;
//     });

//     if(servings.length > 0) {
//       target.removeClass('hidden');
//     }

//   }
// }

if(typeof updateAlgoliaFlavors == "undefined") {
  function updateAlgoliaFlavors(id, variants, handle) {
    let target = $('[data-id*="'+id+'"] .card--servings');
    let flavors = [];
    let url = window.Shopify.routes.root + `products/${handle}`;
    
    variants.forEach(function(variant) {
      if (typeof variant.option3 != "undefined" && variant.option3 != null && !flavors.includes(variant.option3)) {
        flavors.push(variant.option3);
      } else if (typeof variant.option2 != "undefined" && variant.option2 != null && !flavors.includes(variant.option2)) {
        flavors.push(variant.option2);
      }
    });

    if(flavors.length > 0) {
      target.removeClass('hidden');
    } 
    if(flavors.length === 1) {
      target.append(`<a href="${url}">${flavors.length} Flavor</a>`);
    } 
    if(flavors.length > 1) {
      target.append(`<a href="${url}">${flavors.length} Flavors</a>`);
    }
  }
}